module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/navigation/arrow-to-right-8f0c8340553d6becbcb46fdfddecd391.svg";